import { FleLayout } from "../FleLayout"
import { ContinueArrow, SpacerSwitcher, SwitchH1ToH2 } from "../Molecules"
import { FlexRowCenter, Spacer } from "../../atoms/Atoms"
import { IlloChatBubbles } from "../../atoms/Illustrations"
import { Body, BodySmall } from "../../atoms/Bodies"
import { FleLinkWrapper } from "../../atoms/Links"
import { TextLink } from "../../atoms/links/TextLink"
import React from "react"
import L10n from "../../../../lib/carrot-l10n"
import { TopSection } from "../TopSection"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AboutYouInto = () => (
  <FleLayout>
    <TopSection progressStep={2} />
    <FlexRowCenter>
      <IlloChatBubbles />
    </FlexRowCenter>
    <SpacerSwitcher />
    <SwitchH1ToH2>{l` Tell us more about you.`}</SwitchH1ToH2>
    <Spacer height={1} />
    <Body color="black-80">
      {l`These details help us better support you with the right guidance and
        medical info. `}
    </Body>
    <FleLinkWrapper>
      <ContinueArrow to="/fle/about-you/email" />
      <TextLink to="/fle/partner">
        <BodySmall color="black-80">Skip section</BodySmall>
      </TextLink>
    </FleLinkWrapper>
  </FleLayout>
)

export { AboutYouInto }
